<app-nav></app-nav>
<div class="mis-screen">
    <div class="mis-filter">
        <form class="form-inline">
            <div class="form-group">
                <label>From</label>
                <input type="date" class="form-control" />
            </div>
            <div class="form-group">
                <label>To</label>
                <input type="date" class="form-control" />
            </div>
        </form>
    </div>
    <div class="mis-table">
        <table>
            <thead>
                <tr>
                    <th>Order No.</th>
                    <th>Policy No.</th>
                    <th>Client's Name</th>
                    <th>Mobile No.</th>
                    <th>Email</th>
                    <th>State</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                </tr>
                <tr>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                </tr>
                <tr>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                </tr>
                <tr>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                    <td>1523</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>